import { useState, ReactNode } from 'react';

interface TranscriptAccordionProps {
  transcript: ReactNode;
}

const TranscriptAccordion: React.FC<TranscriptAccordionProps> = ({
  transcript,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full pt-2">
      <button
        className="flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-300 focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>Transcript</span>
        <svg
          className={`${
            isOpen ? 'transform rotate-180' : ''
          } w-5 h-5 text-gray-500`}
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <div
        className={`${
          isOpen ? 'block' : 'hidden'
        } bg-white text-gray-700 text-sm p-4 border-t border-gray-200`}
      >
        {transcript}
      </div>
    </div>
  );
};

export default TranscriptAccordion;
